import { css } from "@emotion/css";
import { FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const modalTriggerLinkButtonStyle = css`
    &.sds-base-button.ant-btn {
        margin-inline: ${Spacing["2XS"]}px !important;
        padding: 0;

        font-size: ${FontSizeInPx.COMPACT}px;
        font-weight: ${FontWeight.NORMAL};
        vertical-align: unset;
    }
`;
